<div class="maintenance-board-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
        </li>
      </ul>
    </ul>
    <div class="title-row-flex-both-end">
      <h1 class="main-title">{{langObj ? langObj?.MaintenanceBoard : ('MaintenanceBoard' | translate)}}</h1>
      <!-- <div class="basic-mat-input" style="float: right; margin-top: auto">
            <span class="date-label">Last 30 days</span>
            <mat-form-field appearence="fill" style="padding-left: 15px">
               <mat-label>Choose date range</mat-label> 
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate [formControl]="startDate" />
                <input matEndDate [formControl]="startDate" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon
                  ><mat-select></mat-select
                ></mat-icon> 
              </mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div> -->
    </div>
  </div>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  <form [formGroup]="maintenanceBoardForm">
    <div class="content-top-row content-top-row-order-processing">
      <!-- GROUP -->
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <!-- <mat-label>Status</mat-label> -->
        <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)" placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}"
          panelClass="testClass" name="group">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
            (filteredReturn)="filteredGroups = $event"></mat-select-filter>
          <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
            {{group.EG_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)" placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="plant">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
            (filteredReturn)="filteredPlants = $event"></mat-select-filter>
          <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
            {{plant.PT_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="line"  (selectionChange)="onChangeLine($event)" placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
            (filteredReturn)="filteredLines = $event"></mat-select-filter>
          <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
            {{line.PL_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-select formControlName="unit" placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}" panelClass="testClass" name="unit" (selectionChange)="onSubmit()">
          <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
            (filteredReturn)="filteredUnits = $event"></mat-select-filter>
          <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
            {{unit.PU_Desc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Dropdown -->
    <div class="content-top-row content-top-row-order-processing">
      <div class="inputField">
        <nz-date-picker class="calender-input" id="startPicker" formControlName="dateStart" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
        <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>
      </div>
      <div class="inputField">
        <nz-date-picker class="calender-input" id="endPicker" formControlName="dateEnd" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
        <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>
      </div>
      <div class="btn-position">
        <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
          (click)="onSubmitSearch()" tooltipPosition="top">
          <img src="assets/images/search.png" alt="" width="20px" height="20px">
        </button>
      </div>
      <!-- <div class="btn-position">
        <button mat-raised-button color="accent" class="btn-accent oee-button-w" (click)="today()">Today  </button>
      </div>
      <div class="btn-position">
        <button mat-raised-button color="accent" class="btn-accent" (click)="yesterday()">Yesterday</button>
      </div>
      <div class="btn-position">
        <button mat-raised-button color="accent" class="btn-accent" (click)="lastWeek()">Last Week</button>
      </div>
      <div class="btn-position">
        <button mat-raised-button color="accent" class="btn-accent" (click)="lastMonth()">Last Month</button>
      </div> -->
      <div class="d-flex" style="margin: 10px;">
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="today();showPhase(1)" [class.phase-active]="activeButton === 1"
            matTooltipClass="custom-tooltip" matTooltip="Current Shift">CS</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="yesterday();showPhase(2)" [class.phase-active]="activeButton === 2"
            matTooltipClass="custom-tooltip" matTooltip="Last Shift">LS</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="yesterdayFullDay();showPhase(3)" [class.phase-active]="activeButton === 3"
            matTooltipClass="custom-tooltip" matTooltip="Yesterday">1D</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastWeek();showPhase(4)" [class.phase-active]="activeButton === 4"
            matTooltipClass="custom-tooltip" matTooltip="Last Week">1W</p>
        </div>
        <div class="mr-10" style="margin: inherit;">
          <p class="topBtn mx-2" (click)="lastMonth();showPhase(5)" [class.phase-active]="activeButton === 5"
            matTooltipClass="custom-tooltip" matTooltip="Last Month">1M</p>
        </div>
      </div>
    </div>

    <div class="card-wrapper-list maintenance-board">
      <div class="card-item card-item-five">
        <div class="card">
          <div class="card-suffix-icon">
          </div>
          <div class="content" style="position: relative">
            <o3-percentage-graph [barProperties]="oeeAnalysis"></o3-percentage-graph>
            <p class="graph-title">OEE</p>
          </div>
        </div>
      </div>

      <div class="card-item card-item-five">
        <div class="card">

          <o3-percentage-graph [barProperties]="availabilityAnalysis"></o3-percentage-graph>
          <p class="graph-title">{{langObj ? langObj?.Availability : ('Availability' | translate)}}</p>
        </div>
      </div>
      <div class="card-item card-item-five">
        <div class="card">

          <o3-percentage-graph [barProperties]="performanceAnalysis"></o3-percentage-graph>
          <p class="graph-title">{{langObj ? langObj?.Performance : ('Performance' | translate)}}</p>
        </div>
      </div>
      <div class="card-item card-item-five">
        <div class="card">

          <o3-percentage-graph [barProperties]="qualityAnalysis"></o3-percentage-graph>
          <p class="graph-title merge-style">{{langObj ? langObj?.Quality : ('Quality' | translate)}}</p>
        </div>
      </div>
    </div>

    <!-- Charts -->
    <mat-card>
      <div [chart]="chartMaintenance"></div>
    </mat-card>

    <!-- <div class="chart-group">
      <div class="chart-items">
        <div class="chart-title">Total Shutdown <span style="float: right; color: #2196F3; font-weight: bold;">Count :
          {{countTS.length}} <span style="color: #fcba03; font-weight: bold;"> , Minutes : {{minutesTS |
            number:'1.2-2'}}</span></span></div>
        <div [chart]="charttotalShutdown"></div>
      </div>
      <div class="chart-items">
        <div class="chart-title">Faulty Summary (Top 10)</div>
        <div [chart]="totalShutdownFault"></div>
      </div>
    </div> -->
    <div class="chart-group d3-chart">
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.TotalShutdown : ('TotalShutdown' | translate)}} <span style="float: right; color: #2196F3; font-weight: bold;">Count :
            {{countTS.length}} <span style="color: #fcba03; font-weight: bold;"> , Minutes : {{minutesTS |
              number:'1.2-2'}}</span></span></div>
        <div>
          <div id="chartTS" style="height:300px; width: 450px;">
            <div class="innerCont"
              style="overflow: auto; height:91% ; Width:100% ;position: relative;overflow: hidden;"></div>

          </div>
          <div class="breadcrumb">
            <div class="item">
              <a id="TSlevel0" href="javascript:void();">{{langObj ? langObj?.TotalShutdown : ('TotalShutdown' | translate)}}</a>
              <a id="TSmessageSpan1" href="javascript:void();"></a>
              <a id="TSmessageSpan2" href="javascript:void();"></a>
              <a id="TSmessageSpan3" href="javascript:void();"></a>
              <a id="TSmessageSpan4" href="javascript:void();"></a>
              <a id="TSmessageSpan5" href="javascript:void();"></a>
              <a id="TSmessageSpan6" href="javascript:void();"></a>
            </div>
          </div>

        </div>
      </div>
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.TotalShutdown : ('TotalShutdown' | translate)}}(Top 10)</div>
        <div id="divTS">
          <canvas id="tstTotalShutdown" style="height:600px;"></canvas>
        </div>
      </div>
    </div>

    <div class="chart-group d3-chart">
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.PlannedDowntime : ('PlannedDowntime' | translate)}} <span style="float: right; color: #2196F3; font-weight: bold;">Count :
            {{countPD.length}} <span style="color: #fcba03; font-weight: bold;"> , Minutes : {{minutesPD |
              number:'1.2-2' }}</span></span></div>
        <div>

          <div id="chartPD" style="height:300px; width: 450px;">
            <div class="innerCont"
              style="overflow: auto; height:91% ; Width:100% ;position: relative;overflow: hidden;"></div>

          </div>
          <div class="breadcrumb">
            <div class="item">
              <a id="PDlevel0" href="javascript:void();">{{langObj ? langObj?.PlannedDowntime : ('PlannedDowntime' | translate)}} </a>
              <a id="PDmessageSpan1" href="javascript:void();"></a>
              <a id="PDmessageSpan2" href="javascript:void();"></a>
              <a id="PDmessageSpan3" href="javascript:void();"></a>
              <a id="PDmessageSpan4" href="javascript:void();"></a>
              <a id="PDmessageSpan5" href="javascript:void();"></a>
              <a id="PDmessageSpan6" href="javascript:void();"></a>
            </div>
          </div>

        </div>
      </div>
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.FaultySummary : ('FaultySummary' | translate)}}(Top 10)</div>
        <div id="divPD">
          <canvas id="tsdPlannedDowntime" style="height:600px;"></canvas>
        </div>
      </div>
    </div>
    <div class="chart-group d3-chart">
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.UnPlannedDowntime : ('UnPlannedDowntime' | translate)}}<span
            style="float: right; color: #2196F3; font-weight: bold;">Count : {{countUPD.length}}<span
              style="color: #fcba03; font-weight: bold;"> , Minutes : {{minutesUPD | number:'1.2-2'}}</span></span>
        </div>
        <div>
          <div id="chartUPD" style="height:300px;width: 450px;">
            <div class="innerCont"
              style="overflow: auto; height:91% ; Width:100% ;position: relative;overflow: hidden;"></div>

          </div>
          <div class="breadcrumb">
            <div class="item">
              <a id="UPDlevel0" href="javascript:void();">{{langObj ? langObj?.UnPlannedDowntime : ('UnPlannedDowntime' | translate)}} </a>
              <a id="UPDmessageSpan1" href="javascript:void();"></a>
              <a id="UPDmessageSpan2" href="javascript:void();"></a>
              <a id="UPDmessageSpan3" href="javascript:void();"></a>
              <a id="UPDmessageSpan4" href="javascript:void();"></a>
              <a id="UPDmessageSpan5" href="javascript:void();"></a>
              <a id="UPDmessageSpan6" href="javascript:void();"></a>
            </div>
          </div>

        </div>
      </div>
      <div class="chart-items">
        <div class="chart-title">{{langObj ? langObj?.FaultySummary : ('FaultySummary' | translate)}}(Top 10)</div>
        <div id="divUPD">
          <canvas id="tsdUPlannedDowntime" style="height:600px;"></canvas>
        </div>
      </div>
    </div>
  </form>
  <section>
    <div class="example-button-row">
      <button type="button" class="btn btn-success" (click)="csvExport()" style="margin-top: 30px;"><img
          src="assets/images/csv-file-format.png"></button>
      <button type="button" class="btn btn-success" (click)="excelExport()"
        style="margin-top: 30px; margin-left: 10px;"><i class="fa fa-file-excel-o icon-white"
          aria-hidden="true"></i></button>
    </div>
  </section>
  <mat-card-content>
    <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
      [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" [pagination]="true"
      [paginationPageSize]="10">
    </ag-grid-angular>
  </mat-card-content>
</div>